<template>
  <!-- ログインフォーム -->
  <div class="p-login-form">
    <form id="loginForm" action="/api/login/" @keydown.enter="login">
      <ul class="p-login-form-list">
        <li class="p-login-form-list__item">
          <input-mail :with-error-message="false" />
        </li>
        <li class="p-login-form-list__item">
          <input-password :with-error-message="true" />
        </li>
      </ul>
      <ul class="p-login-form-list p-login-form-list--bottom">
        <li class="p-login-form-list__item">
          <a
            class="c-btn c-btn--blue u-w250"
            name="login"
            href="#"
            @click="login()"
          >
            <p class="c-btn__text">{{ $t("login.login") }}</p>
          </a>
          <div class="p-login-form-suppl">
            {{ $t("login.forgot-password") }}<a class="p-login-form-suppl__link" :href="passwordResetUrl">{{ $t("login.hear") }}</a>
          </div>
        </li>
      </ul>
    </form>
  </div>
  <!-- /ログインフォーム -->
</template>

<script>
import axios from 'axios';

export default {
  props: {
    passwordResetUrl: String,
  },
  mounted() {
    // ページロード時にCSRFトークンを取得してセッションを確立
    this.initializeCsrfToken();
  },
  methods: {
    initializeCsrfToken: function() {
      // CSRFトークンが存在しない場合は、サーバーから取得
      const token = document.head.querySelector('meta[name="csrf-token"]');
      if (!token || !token.content) {
        // セッションを開始してCSRFトークンを取得
        axios.get('/csrf-token').then(response => {
          if (response.data.token) {
            // メタタグを作成または更新
            let metaTag = document.head.querySelector('meta[name="csrf-token"]');
            if (!metaTag) {
              metaTag = document.createElement('meta');
              metaTag.name = 'csrf-token';
              document.head.appendChild(metaTag);
            }
            metaTag.content = response.data.token;

            // axiosのデフォルトヘッダーを設定
            axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.token;
          }
        }).catch(error => {
          console.error('Failed to initialize CSRF token:', error);
        });
      }
    },
    login: function (_event) {
      var loginButton = $('a[name="login"]');
      var loginForm = $('#loginForm');

      // ローディング表示設定
      loginButton.addClass('is-loading').prop('disabled', 'disabled');

      // フォーム要素取得
      const data = {
        email: loginForm.find('input[name=mail]').prop('value'),
        password: loginForm.find('input[name=password]').prop('value'),
      };

      // CSRFトークンを取得してヘッダーに設定
      const token = document.head.querySelector('meta[name="csrf-token"]');

      axios.post(loginForm.prop('action'), data, {
        headers: {
          'X-CSRF-TOKEN': token ? token.content : '',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(res => {
          if(res.data.result == 'OK'){
            location.href = "/coins-admin";
          } else {
            loginButton.removeClass('is-loading').prop('disabled', '');
            if(res.data.errors){
              for (let elementName in res.data.errors) {
                let message = res.data.errors[elementName];

                // エラーメッセージ表示設定
                loginForm.find('input[name=' + elementName + ']')
                  .closest('li')
                  .find('.c-error')
                  .addClass('is-active')
                  .find('.c-error__text')
                  .text(message)
              }
              loginForm.find('.c-input').addClass('is-error');
            }
          }
        })
        .catch(e => {
          let message = '予期せぬエラーが発生しました';
          if (
            e.response &&
            e.response.status === 403 &&
            e.response.data?.message
          ) {
            message = e.response.data.message;
          }
          // エラーメッセージ表示設定
          loginForm.find('input[name=password]')
            .closest('li')
            .find('.c-error')
            .addClass('is-active')
            .find('.c-error__text')
            .text(message);

          setTimeout(() => {
            loginButton.removeClass('is-loading').prop('disabled', '');
          }, 1000);
        });
    },
  },
}
</script>
